import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { ActionSectionComponentProps } from './types';

export const ActionGeneratedSection: FC<ActionSectionComponentProps> = () => {
  return <NodeViewContent />;
};
